// extracted by mini-css-extract-plugin
export default {"containerInvitation":"invitation_containerInvitation__3WAs1","containerButtons":"invitation_containerButtons__hL3Du","logo":"invitation_logo__QBtP8"};